import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router";
import { notification } from "antd";
import { AxiosError, AxiosResponse } from "axios";
import { Loader } from "@mantine/core";
import apiLinks from "@src/apiLinks";
import api from "@src/utils";

const VerifyEmail = () => {
  const { token } = useParams();
  const [Loading, setLoading] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    setLoading(true);
    api
      .post(`${apiLinks.verifyEmail}${token}/`)
      .then((res: AxiosResponse) => {
        setLoading(false);
        if (res.data?.success) {
          notification.success({ message: res.data?.info });
          navigate("/auth");
        } else {
          navigate("/");
          notification.warning({ message: res.data?.info, duration: 5000 });
        }
      })
      .catch((err: AxiosError) => {
        setLoading(false);
        notification.error({ message: err?.message });
      });
  }, [navigate, token]);

  return (
    <div className="flex items-center justify-center ">
      {Loading && <Loader color="blue" size={"xl"} />}
    </div>
  );
};

export default VerifyEmail;
